/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { search, getPositionInfo } from '../api';
import { Search, SearchPosition } from '../api/types/search';
import { Suggestion, SuggestionDetails } from '../types/suggestion';
import { Nullable } from '../utils/types';

type Suggestions = Record<string, Suggestion[]>;

export type TSearch$State = {
  suggestions: Nullable<Suggestions>;
  details: Nullable<SuggestionDetails>;
};

const initialState: TSearch$State = {
  suggestions: null,
  details: null,
};

export const Search$ = createStore<TSearch$State>(initialState);

const { setSuggestions, setDetails, clearSuggestion, clearDetails } = createApi(Search$, {
  // @ts-ignore
  setSuggestions: (state, { result, params }) => {
    return {
      ...state,
      suggestions: {
        [`${params.pattern}`]: result.result,
      },
    };
  },
  // @ts-ignore
  setDetails: (state, { result }) => {
    return { ...state, details: result.result };
  },
  // @ts-ignore
  clearSuggestion: (state) => ({ ...state, suggestions: null }),
  // @ts-ignore
  clearDetails: (state) => ({ ...state, details: null }),
});

export const searchApi = {
  get: createEffect<Search, {}, {}>().use(search),
  getPosition: createEffect<SearchPosition, {}, {}>().use(getPositionInfo),
  clearSuggestion: createEffect(),
  clearDetails: createEffect(),
};

sample({
  clock: searchApi.get.done,
  target: setSuggestions,
});

sample({
  clock: searchApi.getPosition.done,
  target: setDetails,
});

sample({
  clock: searchApi.clearSuggestion,
  target: clearSuggestion,
});

sample({
  clock: searchApi.clearDetails,
  target: clearDetails,
});
